const RegistrationValidator = (t) => {
  let regexs = {
    nameRegex: new RegExp(/^[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]* ?()[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]* ?()[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]*$/),
    firstLastNameRegex: new RegExp(/^[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]* ?()[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]* ?()[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]*$/),
    secondLastNameRegex: new RegExp(/^[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]* ?()[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]* ?()[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]*$/),
    rfcRegex: new RegExp(/^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/),
    moralRfcRegex: new RegExp(/^([A-ZÑ&]{3}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/),
    phoneRegex: new RegExp(/^[-]?[0-9]+[\.]?[0-9]+$/),
    cellphoneRegex: new RegExp(/^[-]?[0-9]+[\.]?[0-9]+$/),
    nameSocialRegex: new RegExp(/^^[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]* ?()[A-Za-z0-9ñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0& .,;:-]* ?()[A-Za-z0-9ñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0& .,;:-]*$/),
    addressRegex: new RegExp(/^[A-Za-z0-9 áéíóúÁÉÍÓÚÑñ.,;:#-]+$/),
    suburbRegex: new RegExp(/^[A-Za-z0-9 áéíóúÁÉÍÓÚÑñ.,;:#-]+$/),
    townRegex: new RegExp(/^[A-Za-z0-9 áéíóúÁÉÍÓÚñÑ.,;:-]+$/),
    stateRegex: new RegExp(/^[A-Za-z0-9 áéíóúÁÉÍÓÚñÑ.,;:-]+$/),
    zipCodeRegex: new RegExp(/(^\d{5}$)|(^\d{5}-\d{4}$)/),
    phoneNumberRegex: new RegExp(/^[-]?[0-9]+[\.]?[0-9]+$/),
    cardName: new RegExp(/^[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]* ?()[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]* ?()[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]*$/),
    securityCode: new RegExp(/^[0-9]{3,4}$/),
    internalNumberRegex: new RegExp(/^[A-Za-z0-9 áéíóúÁÉÍÓÚÑñ.,;:#-]+$/),
    externalNumberRegex: new RegExp(/^[A-Za-z0-9 áéíóúÁÉÍÓÚÑñ.,;:#-]+$/),
    curpRegex: new RegExp(/^([A-Z&]|[a-z&]{1})([AEIOU]|[aeiou]{1})([A-Z&]|[a-z&]{1})([A-Z&]|[a-z&]{1})([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])([HM]|[hm]{1})([AS|as|BC|bc|BS|bs|CC|cc|CS|cs|CH|ch|CL|cl|CM|cm|DF|df|DG|dg|GT|gt|GR|gr|HG|hg|JC|jc|MC|mc|MN|mn|MS|ms|NT|nt|NL|nl|OC|oc|PL|pl|QT|qt|QR|qr|SP|sp|SL|sl|SR|sr|TC|tc|TS|ts|TL|tl|VZ|vz|YN|yn|ZS|zs|NE|ne]{2})([^A|a|E|e|I|i|O|o|U|u]{1})([^A|a|E|e|I|i|O|o|U|u]{1})([^A|a|E|e|I|i|O|o|U|u]{1})([0-9]{2})$/),
  }

  let validators = {
    nameValidator: (value) => {
      if (value === '') return t('registration.validator.nameValidator')
      if (value === '' || value && value.length > 0) {
        return (regexs.nameRegex.test(value) ? '' : t('registration.validator.nameValidator'))
      }
    },
    firstLastNameValidator: (value) => {
      if (value === '') return t('registration.validator.firstLastNameValidator')
      if (value === '' || value && value.length > 0) {
        return (regexs.firstLastNameRegex.test(value) ? '' : t('registration.validator.firstLastNameValidator'))
      }
    },
    secondLastNameValidator: (value) => {
      if (value === '') return t('registration.validator.secondLastNameValidator')
      if (value === '' || value && value.length > 0) {
        return (regexs.secondLastNameRegex.test(value) ? '' : t('registration.validator.secondLastNameValidator'))
      }
    },
    rfcValidator: (value) => {
      if (value && value.length > 0) {
        return (regexs.rfcRegex.test(value.toUpperCase()) ? '' : t('registration.validator.rfcValidato'))
      }
    },
    moralRfcValidator: (value) => {
      if (value && value.length > 0) {
        return (regexs.moralRfcRegex.test(value.toUpperCase()) ? '' : t('registration.validator.rfcValidato'))
      }
    },
    phoneValidator: (value) => {
      if (value && value.length > 0) {
        return (regexs.phoneRegex.test(value) ? '' : t('registration.validator.phoneValidato'))
      }
    },
    cellphoneValidator: (value) => {
      if (value === '' || value === null) return t('registration.validator.cellphoneValidato')
      if (value === '' || value && value.length > 0) {
        return (regexs.cellphoneRegex.test(value) ? '' : t('registration.validator.cellphoneValidato'))
      }
    },
    nameSocialValidator: (value) => {
      if (value && value.length > 0) {
        return (regexs.nameSocialRegex.test(value) ? '' : t('registration.validator.nameSocialValidato'))
      }
    },
    addressValidator: (value) => {
      if (value === '-' || value && value.length > 0) {
        return (regexs.addressRegex.test(value) ? '' : t('registration.validator.addressValidato'))
      }
    },
    suburbValidator: (value) => {
      if (value && value.length > 0) {
        return (regexs.suburbRegex.test(value) ? '' : t('registration.validator.suburbValidato'))
      }
    },
    townValidator: (value) => {
      if (value && value.length > 0 ) {
        return (regexs.townRegex.test(value) ? '' : t('registration.validator.townValidato'))
      }
    },
    stateValidator: (value) => {
      if (value && value.length > 0) {
        return (regexs.stateRegex.test(value) ? '' : t('registration.validator.stateValidato'))
      }
    },
    zipCodeValidator: (value) => {
      if (value && value.length > 0) {
        return (regexs.zipCodeRegex.test(value) ? '' : t('registration.validator.zipCodeValidato'))
      }
    },
    phoneNumberValidator: (value) => {
      if (value && value.length > 0) {
        return (regexs.phoneNumberRegex.test(value) ? '' : t('registration.validator.phoneNumberValidato'))
      }
    },
    internalNumberValidator: (value) => {
      if (value && value.length > 0) {
        return (regexs.internalNumberRegex.test(value) ? '' : t('registration.validator.internalNumberValidato'))
      }
    },
    externalNumberValidator: (value) => {
      if (value && value.length > 0) {
        return (regexs.externalNumberRegex.test(value) ? '' : t('registration.validator.externalNumberValidato'))
      }
    },
    cardNameValidator: (value) => {
      if (value && value.length > 0) {
        return (regexs.cardName.test(value) ? '' : t('registration.validator.cardName'))
      }
    },
    securityCodeValidator: (value) => {
      if (value && value.length > 0) {
        return (regexs.securityCode.test(value) ? '' : t('registration.validator.securityCode'))
      }
    },
    curpValidator: (value) => {
      if (value === '' || value === null) return t('registration.validator.curp')
      if (value === '' || value && value.length > 0) {
        return (regexs.curpRegex.test(value) ? '' : t('registration.validator.curp'))
      }
    }
  }

  return validators
}

export { RegistrationValidator as default }
